/**
 * The person's status on one course as a pill (plan docs/plans/lms-plan.md
 * section 13 tab 2 and the status colours of section 13; 8.4; WP-42).
 * Colour never carries the meaning alone: every pill says its word (G13, the
 * design skill's status pill recipe with the dot).
 */
import type { MyCourseStatus } from '../../api/completions';
import { pillCls } from '../../components/player/styles';
import { statusChip } from './catalog';

export interface CourseStatusChipProps {
  /** The GET /me/status cell for the course; undefined when the course is absent from the map. */
  cell: MyCourseStatus | null | undefined;
}

export function CourseStatusChip({ cell }: CourseStatusChipProps) {
  const chip = statusChip(cell);
  return (
    <span className={pillCls(chip.tone)} data-testid="lms-course-status" data-status={chip.status}>
      <span className="h-1.5 w-1.5 rounded-full bg-current" aria-hidden="true" />
      {chip.text}
    </span>
  );
}

export default CourseStatusChip;
